import wxBridge from '../jsbridge/jsbridge_base.js';
import WxGameJsCoreBridge from '../common/jscore/index';
import { getAllQueryStr } from "../base/mbase";
import env from '../common/env.js';
import Dom from '../base/mdom.js';
/**
 * 参数示例：
 * var params = {
 *      open_game_webview   : "1",
 *      url                 : "https://xxx.xx.xx",      // 链接url
 *      statusBarColor      : "#ffffff",                // bar背景颜色
 *      statusBarStyle      : "black",                  // 字体颜色，只支持black和white
 *      
 *  }
 */
function openWebview(param, callback) {
    let liteAppPathConfig = Dom.window?.WXGAME?.GlobalConfig?.router?.getLiteAppPathConfig?.(param.url); // 获取liteAppPathConfig信息，如果可以获取到，走liteApp跳转
    if( liteAppPathConfig ) {
        let queryStringParams = getAllQueryStr(param.url)
        param.liteAppInfo = {
            appId: liteAppPathConfig.liteapp_info.appid,
            path: liteAppPathConfig.liteapp_info.path,
            query: queryStringParams
        }
        if( env.isiOS ) { // TODO：iOS下跳转到liteapp后不会执行callback，待客户端修复。待修复后加个版本判断，当前先手动触发callback
            wxBridge.invoke('openGameUrlWithExtraWebView', param);
            // 模拟一下异步
            Promise.resolve().then(() => {
                callback({
                    err_msg: "openGameUrlWithExtraWebView:ok"
                })
            })
            return;
        }
    }
    if( param.popCurrentVc ) {
        if( env.isiOS ) {
            // 子webview情况下无法使用
            if( !!window.wgclient?.isChildWebViewMode ) {
                delete param.popCurrentVc;
            }
        }else if( env.isAndroid ) { // 安卓下popCurrentVc参数未实现，通过closeWindow来实现
            let oldCallback = callback;
            callback = function(res) {
                oldCallback(res)
                if( res.err_msg?.indexOf(":ok") > -1 ) {
                    setTimeout(() => {
                        wxBridge.invoke("closeWindow")
                    }, 3000)
                }
            }
        }
    }
    wxBridge.invoke('openGameUrlWithExtraWebView', param, callback);
}
wxBridge.openGameUrlWithExtraWebView = wxBridge.openGameUrlWithExtraWebView  ||function(param, callback) {  
    let useJscore = false;
    // 如果有jscore，则调用jscore的该方法
    if(WxGameJsCoreBridge.hadJscoreInited() && (param.useJscore || WxGameJsCoreBridge.hadPrerendered(param.url))) {
        try {
            useJscore = true;
            WxGameJsCoreBridge
            .openUrl(param)
            .then((res) => {
                console.log('jscore-then', res);
                if(res && res.data && res.data.jsapiRes) {
                    callback(res.data.jsapiRes)
                }else{
                    callback({});
                }
            });
        } catch (error) {
            openWebview(param, callback)
        }
    }else{
        openWebview(param, callback)
    }   
    
    return useJscore;
};

export default wxBridge;

export const {
    openGameUrlWithExtraWebView
} = wxBridge;
